import { MarketType, MemberNoLength } from "../../types/types";

export default function memberNoLengthValidation(market: MarketType, memberNo: string) {
  return memberNo.length === MemberNoLength[market];
}
